'use client'
import { ProjectVerticalDetailFragment, SimilarProjectFragment } from '@/gql/generated/graphql'
import { AllPurposeLink } from '@components/all-purpose-link'
import { verticalRoute } from '@utils/routes'
import { ArrowRightIcon, BodyText, DisplayText } from 'design-configuration/components'
import { useState } from 'react'
import { PaginationButton, PaginationDirection } from '@components/pagination-button'
import { ProjectCard } from '@/app/discover/components/project-card'
import { getVertical, getVerticalTitle } from '@utils/project'
import { OverlineHeader } from '@components/overline-header'
export type SimilarProjectsFooterProps = {
  similarProjects: SimilarProjectFragment[]
  project: ProjectVerticalDetailFragment
}

export const SimilarProjectsFooter = ({ similarProjects, project }: SimilarProjectsFooterProps): React.ReactElement => {
  const vertical = getVertical(project)
  const verticalTitle = getVerticalTitle(project)
  return similarProjects.length ? (
    <div className="py-xl px-md bg-surface-inverted text-on-surface-inverted flex h-full w-full flex-col items-center justify-center">
      <div className="flex h-full w-full flex-col items-start justify-center">
        <div className="">
          <OverlineHeader text="DISCOVER" />
          <div className="gap-x-md flex flex-col sm:flex-row sm:items-end">
            <DisplayText className="font-medium">More from {verticalTitle}</DisplayText>
            <AllPurposeLink
              href={verticalRoute(vertical)}
              className="text-on-surface-variant gap-x-xs mb-2xs flex items-center"
            >
              <BodyText>View all</BodyText>
              <ArrowRightIcon className="w-sm h-sm fill-on-surface-variant" />
            </AllPurposeLink>
          </div>
        </div>

        <div className="gap-xl pt-xl relative hidden h-full w-full grid-cols-2 md:grid lg:grid-cols-4">
          {similarProjects.map((project) => (
            <ProjectCard key={project.name ?? ''} project={project} dark />
          ))}
        </div>
        <div className="mt-xl block h-full w-full md:hidden">
          <SimilarProjectsSlideshow similarProjects={similarProjects} project={project} />
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export const SimilarProjectsSlideshow = ({ similarProjects }: SimilarProjectsFooterProps): React.ReactElement => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const paginate = (direction: PaginationDirection) => {
    if (direction === PaginationDirection.Right) {
      setCurrentSlide((prev) => (prev + 1) % similarProjects.length)
    } else {
      setCurrentSlide((prev) => (prev - 1 + similarProjects.length) % similarProjects.length)
    }
  }

  const project = similarProjects[currentSlide]

  return (
    <div className="relative flex h-auto w-full items-center justify-center">
      <PaginationButton direction={PaginationDirection.Left} onClick={() => paginate(PaginationDirection.Left)} />
      <ProjectCard key={project.name ?? ''} project={project} dark />
      <PaginationButton direction={PaginationDirection.Right} onClick={() => paginate(PaginationDirection.Right)} />
    </div>
  )
}
